import React, { useState } from 'react';
import './Terms.css';

function Terms() {
  const [activeSection, setActiveSection] = useState('terms-of-use');

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-layout">
          {/* Sidebar Navigation */}
          <aside className="terms-sidebar">
            <nav className="sidebar-nav">
              <button
                className={activeSection === 'terms-of-use' ? 'active' : ''}
                onClick={() => scrollToSection('terms-of-use')}
              >
                1. Website terms of use
              </button>
              <button
                className={activeSection === 'terms-conditions' ? 'active' : ''}
                onClick={() => scrollToSection('terms-conditions')}
              >
                2. Terms and conditions
              </button>
              <button
                className={activeSection === 'privacy-policy' ? 'active' : ''}
                onClick={() => scrollToSection('privacy-policy')}
              >
                3. Privacy policy
              </button>
              <button
                className={activeSection === 'cookie-policy' ? 'active' : ''}
                onClick={() => scrollToSection('cookie-policy')}
              >
                4. Cookie policy
              </button>
              <button
                className={activeSection === 'third-party-links' ? 'active' : ''}
                onClick={() => scrollToSection('third-party-links')}
              >
                5. Third Party Links
              </button>
              <button
                className={activeSection === 'gdpr' ? 'active' : ''}
                onClick={() => scrollToSection('gdpr')}
              >
                6. GDPR
              </button>
            </nav>
          </aside>

          {/* Main Content */}
          <div className="terms-content">
            <div id="terms-of-use" className="content-section">
              <h1>Website Terms & Use</h1>
              <p className="last-updated">Last Updated: 06-Oct-2025</p>

          <section className="terms-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Clientalio. By accessing or using our website and services, you agree
              to comply with and be bound by these Terms of Use. Please read them carefully
              before using our platform.
            </p>
            <p>
              We are committed to transparency and privacy. Clientalio takes a number of steps
              to comply with global data protection laws, including the General Data
              Protection Regulation (GDPR) and other applicable privacy regulations.
            </p>
            <p>
              For detailed information about how we handle your personal data, please review
              our latest legal documents below:
            </p>
            <ul className="legal-links">
              <li><a href="#terms-conditions" onClick={(e) => { e.preventDefault(); scrollToSection('terms-conditions'); }}>Terms & Conditions</a></li>
              <li><a href="#privacy-policy" onClick={(e) => { e.preventDefault(); scrollToSection('privacy-policy'); }}>Privacy Policy</a></li>
              <li><a href="#cookie-policy" onClick={(e) => { e.preventDefault(); scrollToSection('cookie-policy'); }}>Cookie Policy</a></li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>2. About Us</h2>
            <p>
              Clientalio is a platform that helps individuals and businesses to collect
              authentic video and text testimonials from clients in a simple and secure way.
            </p>
            <p>
              Features may include recording, uploading, sharing, reviewing, and embedding
              testimonials on websites or social media.
            </p>
            <p>
              We reserve the right to modify or discontinue any feature, temporarily or
              permanently, without prior notice.
            </p>
            <p>
              When you use Clientalio to collect testimonials from your clients, you act as
              the Data Controller for any data collected from your customers. We act as your
              Data Processor, meaning we only process, store, and manage your client data
              strictly to provide our service to you.
            </p>
            <p>
              We do not:
            </p>
            <ul>
              <li>Send marketing or promotional messages to your clients</li>
              <li>Share or sell client data with third parties</li>
              <li>Access or modify testimonial content unless required for technical or support purposes</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. Accessing Our Website</h2>
            <p>
              Our servers and databases are securely hosted and maintained over cloud. We use
              a limited number of trusted third-party providers. Every third-party service
              provider we engage with is contractually bound to comply with applicable data
              protection standards and maintain strict data security.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Our Services</h2>
            <p>
              Clientalio provides tools that enable users to:
            </p>
            <ul>
              <li>Collect video, text, and image testimonials</li>
              <li>Embed testimonials on websites</li>
              <li>Manage and showcase reviews</li>
              <li>Sync testimonials with third-party CRMs or marketing tools via integrations</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Payments & Subscriptions</h2>
            <p>
              We offer free and paid subscription plans. Paid plans provide additional
              features such as custom branding, HD video, CRM sync, and priority support. 
              Payments are processed securely through authorized payment partners and are 
              shown in INR (₹) where applicable.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Data Privacy & GDPR Compliance</h2>
            <p>
              Clientalio is fully committed to data protection and GDPR compliance. When you
              use our platform to collect testimonials, you act as the Data Controller, and
              Clientalio acts as the Data Processor. We only process your data as necessary to
              provide the Service and will not send marketing emails to your clients or
              sell/share their data.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. User Responsibilities</h2>
            <p>
              By using Clientalio, you agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the platform in compliance with all applicable laws</li>
              <li>Not use the service for any unlawful or fraudulent purposes</li>
              <li>Obtain proper consent from clients before collecting their testimonials</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>8. Intellectual Property</h2>
            <p>
              All content, trademarks, logos, and intellectual property on Clientalio remain
              the property of BWays Techno Solution. You may not copy, reproduce, or
              distribute any content without prior written permission.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Limitation of Liability</h2>
            <p>
              Clientalio and BWays Techno Solution shall not be liable for any indirect,
              incidental, special, or consequential damages arising from your use of the
              platform. Our total liability shall not exceed the amount paid by you for the
              service in the last 12 months.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms of Use at any time. Changes will be
              effective immediately upon posting. Your continued use of the platform
              constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about these Terms of Use, please contact us:
            </p>
            <ul>
              <li>Email: <a href="mailto:support@clientalio.com">support@clientalio.com</a></li>
              <li>Legal: <a href="mailto:legal@clientalio.com">legal@clientalio.com</a></li>
            </ul>
            <p>
              Registered Office: Rohini, New Delhi, India
            </p>
            <p>
              Owned and operated by BWays Techno Solution
            </p>
          </section>
            </div>

            {/* Terms and Conditions Section */}
            <div id="terms-conditions" className="content-section">
              <h1>Terms & Conditions</h1>
              <p className="last-updated">Last Updated: 10-Sep-2024</p>

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  This page, along with our Privacy Policy and Website Terms of Use, outlines the
                  legal terms and conditions under which Clientalio makes available its online
                  testimonial collection and management platform (the "Service"). By creating an
                  account, accessing, or using our Service in any manner, you agree to be bound by
                  these Terms. If you do not agree, please discontinue use immediately.
                </p>
              </section>

              <section className="terms-section">
                <h2>2. Information About Us</h2>
                <p>
                  Clientalio ("the Platform"), owned and operated by BWays Techno Solution ("we",
                  "our", "us") operates the website clientalio.com. We are registered sole
                  proprietorship in Delhi, India.
                </p>
                <p>
                  Registered Office: Rohini, New Delhi, India<br />
                  Contact Email: <a href="mailto:support@clientalio.com">support@clientalio.com</a>
                </p>
              </section>

              <section className="terms-section">
                <h2>3. Our Services</h2>
                <p>
                  Clientalio provides tools that enable users to collect video, text, and image
                  testimonials, embed testimonials on websites, manage and showcase reviews, and
                  sync testimonials with third-party CRMs or marketing tools via integrations.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. Payments & Subscriptions</h2>
                <p>
                  We offer free and paid subscription plans. Paid plans provide additional
                  features such as custom branding, HD video, CRM sync, and priority support. Payments
                  are processed securely through authorized payment partners and are shown in INR
                  (₹) where applicable.
                </p>
              </section>

              <section className="terms-section">
                <h2>5. Data Privacy & GDPR Compliance</h2>
                <p>
                  Clientalio is fully committed to data protection and GDPR compliance. When you
                  use our platform to collect testimonials, you act as the Data Controller, and
                  Clientalio acts as the Data Processor. We only process your data as necessary to
                  provide the Service and will not send marketing emails to your clients or
                  sell/share their data.
                </p>
              </section>
            </div>

            {/* Privacy Policy Section */}
            <div id="privacy-policy" className="content-section">
              <h1>Privacy Policy</h1>
              <p className="last-updated">Last Updated: 06-Oct-2025</p>

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  Welcome to Clientalio. We respect your privacy and are committed to protecting
                  your personal data. This Privacy Policy explains how we collect, use, store, and
                  protect information when you visit our website or use our services.
                </p>
              </section>

              <section className="terms-section">
                <h2>2. Data We Collect</h2>
                <p>
                  We may collect information you provide directly (name, email, company name,
                  testimonial content), information collected automatically (IP address, browser,
                  device, usage data), and cookies/tracking data. See our Cookie Policy for details.
                </p>
              </section>

              <section className="terms-section">
                <h2>3. How We Use Your Data</h2>
                <p>
                  We use personal data to deliver and improve our services, manage accounts,
                  respond to support requests, send important service updates (not marketing), and
                  analyze service performance. We never use your data for unauthorized marketing or
                  sell it to third parties.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. How We Store and Protect Your Data</h2>
                <p>
                  All data is securely stored on cloud servers. We use industry-standard
                  encryption and security measures and engage third parties only under applicable data
                  protection contracts. You can email for any issue at <a href="mailto:legal@clientalio.com">legal@clientalio.com</a>.
                </p>
              </section>
            </div>

            {/* Cookie Policy Section */}
            <div id="cookie-policy" className="content-section">
              <h1>Cookie Policy</h1>
              <p className="last-updated">Last Updated: 06-Oct-2025</p>

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  At Clientalio, we're all about transparency — including how we use cookies. This
                  Cookie Policy explains what cookies are, how we use them on our website, and
                  your choices regarding their use.
                </p>
              </section>

              <section className="terms-section">
                <h2>2. What Are Cookies?</h2>
                <p>
                  Cookies are tiny text files stored on your device when you visit a website. They
                  help sites function, improve user experience, and provide analytics.
                </p>
              </section>

              <section className="terms-section">
                <h2>3. How We Use Cookies</h2>
                <p>
                  We use cookies to keep you logged in securely, save preferences, analyze site
                  traffic, and deliver a smoother, personalized experience. We do not use cookies to
                  collect personal data without your consent or sell your information.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. Managing Cookies</h2>
                <p>
                  You can manage or delete cookies through your browser settings. Disabling
                  cookies may affect your experience or certain features.
                </p>
              </section>

              <section className="terms-section">
                <h2>5. Third-Party Cookies</h2>
                <p>
                  We may use third-party tools like Google Analytics or Meta Pixel. These partners
                  comply with GDPR standards and may use cookies to collect anonymous visit data.
                </p>
              </section>
            </div>

            {/* Third-Party Links Section */}
            <div id="third-party-links" className="content-section">
              <h1>Third-Party Links Policy</h1>
              <p className="last-updated">Last Updated: 06-Oct-2025</p>

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  At Clientalio, transparency and user trust are at the core of everything we do.
                  This Third-Party Links Policy explains how we handle links to other websites or
                  services that are not operated by us.
                </p>
              </section>

              <section className="terms-section">
                <h2>2. Third-Party Links on Our Website</h2>
                <p>
                  Our website may include links to third-party websites, tools, or integrations
                  for your convenience. These sites are not controlled by Clientalio and we are not
                  responsible for their content, policies, or data handling practices.
                </p>
                <p>
                  We recommend reviewing any third-party privacy and cookie policies before
                  sharing personal information.
                </p>
              </section>

              <section className="terms-section">
                <h2>3. Use of Third-Party Services</h2>
                <p>
                  To deliver certain features, we may rely on trusted third-party services. Each
                  provider is vetted and operates under GDPR-compliant contracts. If a partner is
                  located outside the EEA, we use approved safeguards such as Standard Contractual
                  Clauses.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. Liability Disclaimer</h2>
                <p>
                  Clientalio cannot be held responsible for damages or data loss arising from use
                  of external sites. Accessing third-party links is at your own risk.
                </p>
              </section>
            </div>

            {/* GDPR Section */}
            <div id="gdpr" className="content-section">
              <h1>GDPR Compliance Policy</h1>
              <p className="last-updated">Last Updated: 06-Oct-2025</p>

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  At Clientalio, we take your privacy seriously. We've implemented strict measures
                  to comply with the General Data Protection Regulation (GDPR) — ensuring that
                  your data is collected, processed, and stored responsibly.
                </p>
                <p>
                  For transparency about how we handle data, please review our related documents:
                </p>
                <ul className="legal-links">
                  <li><a href="#terms-conditions" onClick={(e) => { e.preventDefault(); scrollToSection('terms-conditions'); }}>Terms & Conditions</a></li>
                  <li><a href="#privacy-policy" onClick={(e) => { e.preventDefault(); scrollToSection('privacy-policy'); }}>Privacy Policy</a></li>
                  <li><a href="#cookie-policy" onClick={(e) => { e.preventDefault(); scrollToSection('cookie-policy'); }}>Cookie Policy</a></li>
                </ul>
              </section>

              <section className="terms-section">
                <h2>2. About Us</h2>
                <p>
                  When you use Clientalio, you — as the user or organization — act as the data
                  controller. Clientalio acts as the data processor, and we process data only as
                  necessary to deliver our services. We do not send marketing emails to your
                  customers, do not share or sell data to third parties, and will delete your data upon
                  request in compliance with GDPR's Right to Erasure (Article 17).
                </p>
              </section>

              <section className="terms-section">
                <h2>3. Data Hosting and Storage</h2>
                <p>
                  All servers and databases powering Clientalio are securely hosted in on cloud
                  servers. Third parties used for technical, analytics, or support purposes are
                  contractually bound to applicable data protection terms.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. Your GDPR Rights</h2>
                <p>
                  Under the GDPR you have rights including Access, Rectification, Erasure,
                  Restrict Processing, Data Portability, and the Right to Object. To exercise any of
                  these rights contact <a href="mailto:support@clientalio.com">support@clientalio.com</a>.
                </p>
              </section>

              <section className="terms-section">
                <h2>5. Security Measures</h2>
                <p>
                  We use end-to-end encryption for sensitive data, regular security audits, access
                  control, and authentication measures to protect your information.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
